import { Link } from "react-router-dom";

const NuestrosServicios = () => {
    const services = [
        { name: "1.- Prestadora de servicios"},
        { name: "2.- Consultoría en Gestión Empresarial" },
        { name: "3.- Renta de Hidrolavadoras y Fumigadoras"},
    ];

    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 bg-estra">
            <div className="h-fit py-12 flex flex-col gap-4 p-4">
                <h2 className="text-center text-4xl font-semibold text-white"> Areas de especialización </h2>
                <div className="h-1 w-full bg-yellow-400" />
            </div>
            <div className="h-[65vh] grid grid-cols-1 p-4 md:p-12 gap-4">
                {services.map((service, index) =>
                    <Link
                        to="/services"
                        key={index}
                        className="relative group h-full md:h-full overflow-hidden shadow-lg p-4 flex flex-col items-center justify-center"
                    >
                            <span className="text-white text-center text-3xl font-semibold">
                                {service.name}
                            </span>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default NuestrosServicios;
